import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const ReduceYourDoubleChin = lazyWithPreload(
  () => import('./ReduceYourDoubleChin'),
)
